import { render, staticRenderFns } from "./ResubmitHongkong.vue?vue&type=template&id=03079774"
import script from "./ResubmitHongkong.vue?vue&type=script&lang=js"
export * from "./ResubmitHongkong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports